/** ユーザー権限名 */
export const USER_ROLE_NAME = Object.freeze({
  admin: 'admin',
  marker: 'marker',
  academy: 'academy',
  branch: 'branch',
  student: 'student',
})

/** 授業モードコード */
export const STUDY_MODE_CODE = Object.freeze({
  normal: 'TJ',
  recommend: 'LV',
  adjust: 'RI',
} as const)

/** 授業モード名 */
export const STUDY_MODE_NAME = Object.freeze({
  TJ: '通常',
  LV: 'レコメンド',
  RI: 'アジャスト',
} as const)

export type StudyModeCodeType = typeof STUDY_MODE_CODE[keyof typeof STUDY_MODE_CODE] | null

/** QRコードログイン用区切り文字 */
export const QR_LOGIN_PARAM_SEPARATOR = '|'

/** 選択肢ラベルの自動採番カタカナ一覧 */
export const DEFAULT_CHOICE_LABELS = Object.freeze([
  'ア',
  'イ',
  'ウ',
  'エ',
  'オ',
  'カ',
  'キ',
  'ク',
  'ケ',
  'コ',
  'サ',
  'シ',
  'ス',
  'セ',
  'ソ',
  'タ',
  'チ',
  'ツ',
  'テ',
  'ト',
  'ナ',
  'ニ',
  'ヌ',
  'ネ',
  'ノ',
  'ハ',
  'ヒ',
  'フ',
  'ヘ',
  'ホ',
  'マ',
  'ミ',
  'ム',
  'メ',
  'モ',
  'ヤ',
  'ユ',
  'ヨ',
  'ラ',
  'リ',
  'ル',
  'レ',
  'ロ',
  'ワ',
  'ヲ',
  'ン',
])
